import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, Check } from "lucide-react";
import { SiteLayout } from "../../components/site/SiteLayout";
import { useSeo } from "../../lib/seo";
import { productCertisfy } from "../../lib/content";
import { AnimatedHero } from "../../components/site/AnimatedHero";
import { CTABlock } from "../ServicesPage";

export default function CertisfyPage() {
  useSeo({
    title: "Certisfy — Compliance & Document Workflow",
    description: productCertisfy.tagline,
    path: "/products/certisfy",
  });
  return (
    <SiteLayout>
      <section className="border-b border-border">
        <div className="container-wald py-12">
          <Link to="/products" data-testid="certisfy-back" className="inline-flex items-center gap-2 text-sm opacity-70 hover:opacity-100">
            <ArrowLeft size={14} strokeWidth={2} /> All products
          </Link>
        </div>
      </section>
      <section className="border-b border-border relative overflow-hidden">
        <AnimatedHero className="absolute inset-0 w-full h-full text-[color:var(--wald-slate)] dark:text-[color:var(--wald-mist)] opacity-70 pointer-events-none" />
        <div className="container-wald py-20 md:py-28 relative">
          <div className="eyebrow mb-6">Product · Certisfy</div>
          <h1 className="font-display text-4xl md:text-6xl leading-[1.02] tracking-tight max-w-4xl">
            {productCertisfy.tagline}
          </h1>
          <p className="mt-6 max-w-2xl opacity-85 leading-relaxed text-lg">{productCertisfy.intro}</p>
          <a
            href={productCertisfy.url}
            target="_blank"
            rel="noreferrer noopener"
            data-testid="certisfy-visit-link"
            className="btn-copper mt-8 inline-flex"
          >
            Visit Certisfy <ArrowUpRight size={14} strokeWidth={2} />
          </a>
        </div>
      </section>
      <section className="border-b border-border bg-card">
        <div className="container-wald py-20">
          <div className="grid grid-cols-12 gap-8">
            <div className="col-span-12 md:col-span-5">
              <div className="eyebrow mb-4">What it does</div>
              <h2 className="font-display text-3xl md:text-4xl tracking-tight max-w-md leading-[1.05]">
                Compliance and document handling, in one system.
              </h2>
            </div>
            <div className="col-span-12 md:col-span-7">
              <ul className="border-t border-border">
                {productCertisfy.capabilities.map((c) => (
                  <li key={c} className="border-b border-border py-5 flex gap-4">
                    <Check size={18} className="text-[color:var(--wald-copper)] mt-0.5 shrink-0" strokeWidth={2} />
                    <span className="text-base leading-relaxed">{c}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
      <CTABlock />
    </SiteLayout>
  );
}
